const users = {
  users: {
    pageHeader: 'Usuários',
    addNewUser: '+ Adicionar novo usuário',
    name: 'Nome',
    role: 'Função',
    company: 'Empresa',
    status: 'Status',
    noUser: '** Nenhum usuário disponível **',
    emailMatch: 'Digite o mesmo valor novamente.',
    validEmail: 'Insira um endereço de e-mail válido.',
    fieldRequired: 'Este campo é obrigatório.',
    userFormHeader: 'Adicionar novo usuário',
    userProfile: 'Perfil de usuário',
    defaultEmailHelpText: 'Um e-mail explicando como fazer login será enviado para este endereço.',
    active: 'Ativo',
    email: 'E-mail',
    confirmEmail: 'Confirmar e-mail',
    firstName: 'Primeiro nome',
    lastName: 'Sobrenome',
    phoneNumber: 'Telefone',
    preferredLocale: 'Local preferido',
    units: 'Unidades',
    addUser: 'Adicionar usuário',
    updateUser: 'Atualizar usuário',
    supportTechnician: 'Técnico de Suporte',
    profileAdministrator: 'Administrador de Perfil',
    profileApprover: 'Aprovador de Perfil',
    administrator: 'Administrador',
    user: 'Usuário',
    viewOnly: 'Exibir apenas',
    demonstration: 'Demonstração',
    errorMessageLengthPhone: 'Máximo de 50 caracteres permitidos',
    all: 'Todos',
    inactive: 'Inativo',
    termsAndServices: 'Apenas o proprietário do sistema pode facultar o acesso às suas instalações. Sem aprovação por escrito do proprietário do sistema, os instaladores não podem permitir o acesso a outras empresas nem a utilizadores fora da sua empresa. Li e aceito as %{termsService} da Enphase e li a %{privacyPolicy} da Enphase. Compreendo que a violação destas condições pode resultar na suspensão ou no encerramento da minha conta Enlighten.',
    privacyPolicy: 'Política de Privacidade',
    termsService: 'Condições do Serviço',
  }
};

export default users;
